import type { SxProps, Theme } from '@mui/material/styles';
import {
  tabletLandscapeQuery,
  ultraWideDesktopQuery,
  wideDesktopQuery,
} from '../../common/viewportBreakpoints';

export const GAMES_BROWSE_PAGE_SIZE = 50;

export const GAMES_BROWSE_GRID_COLUMNS = {
  xs: 'repeat(2, minmax(0, 1fr))',
  sm: 'repeat(3, minmax(0, 1fr))',
  lg: 'repeat(4, minmax(0, 1fr))',
} as const;

/** Side-by-side browse panels are half width — use fewer columns than full-width grids. */
export const GAMES_BROWSE_PANEL_GRID_COLUMNS = {
  xs: 'repeat(1, minmax(0, 1fr))',
  sm: 'repeat(2, minmax(0, 1fr))',
  md: 'repeat(2, minmax(0, 1fr))',
  lg: 'repeat(2, minmax(0, 1fr))',
  xl: 'repeat(3, minmax(0, 1fr))',
  xxl: 'repeat(3, minmax(0, 1fr))',
  xxxl: 'repeat(4, minmax(0, 1fr))',
} as const;

export const gamesBrowsePanelSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  height: '100%',
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  overflow: 'hidden',
};

export const gamesBrowseScrollAreaSx: SxProps<Theme> = {
  position: 'relative',
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowAnchor: 'none',
};

export const gamesBrowseItemLabelSx: SxProps<Theme> = {
  display: 'block',
  fontSize: { xs: 13, sm: 14 },
  lineHeight: 1.35,
  fontWeight: 500,
  [`@media ${tabletLandscapeQuery}`]: {
    fontSize: 15,
  },
  [`@media ${wideDesktopQuery}`]: {
    fontSize: 16,
  },
  [`@media ${ultraWideDesktopQuery}`]: {
    fontSize: 17,
  },
};

export const gamesBrowseItemMetaSx: SxProps<Theme> = {
  display: 'block',
  color: 'text.secondary',
  fontSize: { xs: 11, sm: 12 },
  lineHeight: 1.3,
  [`@media ${tabletLandscapeQuery}`]: {
    fontSize: 13,
  },
  [`@media ${wideDesktopQuery}`]: {
    fontSize: 14,
  },
  [`@media ${ultraWideDesktopQuery}`]: {
    fontSize: 15,
  },
};
